module.exports = __webpack_public_path__ + "media/icons/avatar-8777d701ded028e6c507d4330b0737e3.svg";